import { Editor } from 'slate';
import { MarkType } from '../types';

// Is node (within editor) the given 'mark' (format) type
export const isMarkActive = (editor: Editor, markType: MarkType): boolean => {
	const marks = Editor.marks(editor);
	return marks ? marks[markType] === true : false;
};
